import { render } from "./ViewCollection.vue?vue&type=template&id=7ae8939b&ts=true"
import script from "./ViewCollection.vue?vue&type=script&lang=ts"
export * from "./ViewCollection.vue?vue&type=script&lang=ts"

import "./ViewCollection.vue?vue&type=style&index=0&id=7ae8939b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__